const Model = require("../types/Model");

module.exports = Model({
	name: "accountdeletion",

	init,
	triggers
});

function triggers(){
	return {
		"open": handleOpen,
		"close": handleClose
	};
}

function init(){
	this.push({
		open: false
	});
}

function handleOpen(){
	this.extend({
		open: true
	});
	this.emit("usermetrics:trigger:track", "open account deletion popup");
}

function handleClose(){
	this.extend({
		open: false
	});
	this.emit("usermetrics:trigger:track", "close account deletion popup");
}